import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-education',
    templateUrl: './education.component.html',
    styleUrls: ['./education.component.scss']
})
export class EducationComponent implements OnInit {

  title = "Index Funds: The 12-Step Recovery Program for Active Investors";

  constructor(private seoservice: SeoService, private meta: Meta) { }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'index funds, 12 step recovery program, active investing, catholic investing, catholic index funds'});
    this.meta.addTag({name: 'description', content: 'Index Funds: The 12-Step Recovery Program for Active Investors aims to change to way the world invests.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
